import "./Core.scss";
import Core1 from "../../assets/images/oca-page/oca-core-1.svg";
import Core2 from "../../assets/images/oca-page/oca-core-2.svg";

const Core = ({}) => {
  return (
    <div className="core-paper-root">
      <div className="container">
        <span className="core-title">Core Features</span>
        <span className="core-subtitle mt-20">
          OC Achievements provides a seamless way to earn, verify, and showcase
          your educational credentials on-chain. Designed for learners,
          educators, and developers, our platform ensures secure, decentralized
          recognition of skills and achievements, empowering you to take control
          of your learning journey.
        </span>
        <div className={"relative flex justify-end mt-60"}>
          <div className={"core-card flex flex-col items-end justify-center"}>
            <span className={"core-card_title w-65p"}>
              Simple, Secure, Meaningful
            </span>
            <span className={"core-card_subtitle w-65p"}>
              Getting started is easy. Create your OC-ID to establish your
              secure digital identity on EDU Chain. As you learn and grow
              through courses, internships, and programs, you'll collect
              blockchain-verified achievements that showcase your skills. Share
              your credentials with employers worldwide, maintaining full
              control over your personal information.
            </span>
          </div>
          <div className="core-img-1">
            <img className={"w-100"} src={Core1} alt={""} />
          </div>
        </div>
        <div className={"relative flex justify-start mt-70"}>
          <div
            className={
              "core-card second-core-card flex flex-col items-start justify-center"
            }
          >
            <span className={"core-card_title w-65p"}>Built for Growth</span>
            <span className={"core-card_subtitle w-65p"}>
              We believe learning should be recognized, verified, and valued.
              Our institutional-grade platform ensures your achievements are
              secure while remaining simple to use. Connect with opportunities,
              join our global community, and build a verified record of your
              professional journey.
            </span>
          </div>
          <div className="core-img-2">
            <img className={'w-100'} src={Core2} alt={""} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Core;
